import ViewAllNotifications from './ViewAllNotifications';

const Index = () => {
	return <ViewAllNotifications />;
};
export default Index;
